document.addEventListener("DOMContentLoaded", () => {
  // 关闭按钮
  const closeIconSvg =
      '<span  class="icon-close"><i class="sr-only">delete</i><svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.2 17.744L12 12.944L16.8 17.744L17.744 16.8L12.944 12L17.744 7.2L16.8 6.256L12 11.056L7.2 6.256L6.256 7.2L11.056 12L6.256 16.8L7.2 17.744ZM12.004 24C10.3453 24 8.78533 23.6853 7.324 23.056C5.86356 22.4258 4.59289 21.5707 3.512 20.4907C2.43111 19.4116 1.57556 18.1422 0.945333 16.6827C0.315111 15.2231 0 13.6636 0 12.004C0 10.3453 0.314667 8.78533 0.944 7.324C1.57422 5.86356 2.42933 4.59289 3.50933 3.512C4.58844 2.43111 5.85778 1.57556 7.31733 0.945333C8.77689 0.315111 10.3364 0 11.996 0C13.6547 0 15.2147 0.314667 16.676 0.944C18.1364 1.57422 19.4071 2.42933 20.488 3.50933C21.5689 4.58844 22.4244 5.85778 23.0547 7.31733C23.6849 8.77689 24 10.3364 24 11.996C24 13.6547 23.6853 15.2147 23.056 16.676C22.4258 18.1364 21.5707 19.4071 20.4907 20.488C19.4116 21.5689 18.1422 22.4244 16.6827 23.0547C15.2231 23.6849 13.6636 24 12.004 24ZM12 22.6667C14.9778 22.6667 17.5 21.6333 19.5667 19.5667C21.6333 17.5 22.6667 14.9778 22.6667 12C22.6667 9.02222 21.6333 6.5 19.5667 4.43333C17.5 2.36667 14.9778 1.33333 12 1.33333C9.02222 1.33333 6.5 2.36667 4.43333 4.43333C2.36667 6.5 1.33333 9.02222 1.33333 12C1.33333 14.9778 2.36667 17.5 4.43333 19.5667C6.5 21.6333 9.02222 22.6667 12 22.6667Z" fill="#121212"/></svg></span>';

  // 产品对比的候选列表
  const _compareProductsOrigin = [];
  const compareProducts = new Proxy(_compareProductsOrigin, {
      get(target, property, receiver) {
          return target[property];
      },
      // target：数据对象；property： 发生变化的数据对应的属性名；value：发生变化后新的值
      set(target, property, value) {
          target[property] = value;
          onCompareProductsChanged(); // 数据发生变化时，用 DOM 操作更新视图
          saveCompareProductsToLocalStorage(); // 保存数据到本地存储
          return true;
      },
  });

  // 从本地存储中恢复数据
  function restoreCompareProductsFromLocalStorage() {
      const storedData = localStorage.getItem('compareProducts');
      if (storedData) {
          const products = JSON.parse(storedData);
          products.forEach(product => {
              compareProducts.push(product);
              $(`.product-card-wrapper[data-id=${product.id}]`).addClass('active');
          });
      }
  }

  // 保存数据到本地存储
  function saveCompareProductsToLocalStorage() {
      localStorage.setItem('compareProducts', JSON.stringify(compareProducts));
  }

  // 原数据对象
  const originData = {
      variant: null, // 产品变体
      isLoading: false, // 加载中
  };

  const proxyHander = {
      get(target, key) {
          return target[key];
      },
      set(target, property, value) {
          target[property] = value;
          handleProxyChanged(target, property, value);
          return true;
      },
  };

  // 代理对象
  const proxyData = new Proxy(originData, proxyHander);

  // 代理对象数据发生变化
  function handleProxyChanged(target, property, value) {
      if (property == "variant") {
          // 变体变化，根据新变体：value，更新视图
      }
      if (property == "isLoading") {
          // 加载状态变化，根据新加载状态：value，更新视图
      }
  }

  listenCompareCheckbox();
  restoreCompareProductsFromLocalStorage(); // 页面加载时恢复数据

  function listenCompareCheckbox() {
      $(".product-card-wrapper .compare-check-wrapper").on("click", function (e) {
          const $this = $(this).parents(".product-card-wrapper");
          const pHandle = $this.attr("data-handle");
          const pId = $this.attr("data-id");
          const pImage = $this.find(".pro-featured-media").attr("src");
          console.log(pHandle, pId, pImage);
          const findIndex = compareProducts.findIndex((v) => v.id == pId);
          if (findIndex < 0 && compareProducts.length < 4) {
              // 该产品没有在候选中，并且候选队列未满，添加到候选
              const compareProduct = {
                  id: pId,
                  handle: pHandle,
                  image: pImage,
              };
              compareProducts.push(compareProduct);
              $this.addClass("active");
          } else if (findIndex >= 0) {
              // 已在候选中，移除候选
              compareProducts.splice(findIndex, 1);
              $this.removeClass("active");
          }
          e.stopPropagation();
          e.preventDefault();
          return false;
      });
  }

  // 产品对比候选发生改变时触发
  function onCompareProductsChanged() {
      if (compareProducts.length < 2) {
          $(".collection-compare-panel__btn-compare").attr("disabled", "true");
      } else {
          $(".collection-compare-panel__btn-compare").removeAttr("disabled");
      }
      if (compareProducts.length > 0) {
          $(".collection-compare-panel").show();
          $("body").addClass("hide-smile-ui-container");
      } else {
          $(".collection-compare-panel").hide();
          $("body").removeClass("hide-smile-ui-container");
      }
      try {
          // 根据数据变化，更新视图元素
          $(".collection-compare-panel__products>li").each(function (i, el) {
              const $el = $(el);
              const oldId = $el.attr("data-id");
              const newProduct = compareProducts[i];
              if (newProduct == undefined) {
                  // 有元素，但新的数据说这里是无的，于是清空元素内容
                  $el.html("");
              } else if (oldId != newProduct.id) {
                  // 数据和元素对应不上，更新元素
                  const $newEl = $(
                      `<li data-id=${newProduct.id}><div class="item-inner"><img src='${newProduct.image}'>${closeIconSvg}</div></li>`
                  );
                  $el.html($newEl);
              }
              // 数据和元素能对应上，不更新元素
          });
      } catch (error) {
          console.error(error);
      }
  }

  /** 产品对比候选面板的事件 */
  $(".collection-compare-panel__btn-compare").on("click", function () {
      const productHandleList = compareProducts.map((v, i) => v.handle);
      const collectionHandle = $("[data-section-type][data-collection]").attr("data-collection");
      window.location.href = `/pages/products-compare?filter.collection=${collectionHandle}&filter.products=${productHandleList}`;
  });

  $(".collection-compare-panel__btn-cancel").on("click", function () {
      compareProducts.length = 0;
      $('.product-card-wrapper').removeClass('active')

      // 清空数据后保存到本地存储
      saveCompareProductsToLocalStorage(); 
  });

  $(".collection-compare-panel__products").delegate(
      "li .icon-close",
      "click",
      function (e) {
          const $this = $(this);
          const $item = $this.closest("li");
          const pId = $item.attr("data-id");
          const findIndex = compareProducts.findIndex((v) => v.id == pId);
          if (findIndex >= 0) compareProducts.splice(findIndex, 1);
          const $productCard = $(`.product-card-wrapper[data-id=${pId}]`);
          $productCard.removeClass("active");

          // 移除产品后保存到本地存储
          saveCompareProductsToLocalStorage(); 
      }
  );
});
